const CONSTANTS = require('./constants.js');

$(function () {

  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
      return null;
    }
    else {
      return results[1] || 0;
    }
  }

  // Region Processing
  var reg = CONSTANTS.regions[$.urlParam('region')];

  if ($.urlParam('region')) {
    $('a.navbar-page-link').each(function () {
      var value = $(this).attr('href');
      $(this).attr('href', '/' + $.urlParam('region') + value);
    });
  }

});



// WEBPACK FOOTER //
// ./assets/js/region.js